import axios from 'axios';


export const getElementAlias = (isWorkbench:boolean) => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`shift/element-alias?where=`+isWorkbench);
};
export const addElementAlias = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`shift/element-alias/add`, obj, {
    headers,
  });
};
export const editElementAlias = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`shift/element-alias/update`, obj, {
    headers,
  });
};
export const deleteElementAlias = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`shift/element-alias/delete`, obj, {
    headers,
  });
};
